"use client";

import Image from "next/image";
import { useLanguage } from "../../context/LanguageContext";
import { bodyTextClass, sectionHeadingClass, sectionLabelClass } from "../typography";

type HeadingLevel = "h1" | "h2";

type AboutSectionProps = {
  headingLevel?: HeadingLevel;
};

export default function AboutSection({ headingLevel = "h2" }: AboutSectionProps): JSX.Element {
  const { t } = useLanguage();
  const HeadingTag: HeadingLevel = headingLevel;

  return (
    <section id="about" className="scroll-mt-28 py-16" data-testid="about-section">
      <div className="mx-auto max-w-5xl px-4">
        <div className="flex flex-col gap-10 md:grid md:grid-cols-[auto,1fr] md:gap-12">
          {/* Photo column */}
          <div className="flex justify-center md:justify-start">
            <div className="flex w-full max-w-xs flex-col items-center rounded-2xl border border-slate-200 bg-white p-4 shadow-lg transition-colors dark:border-slate-800 dark:bg-slate-900">
              <div className="overflow-hidden rounded-2xl shadow-md ring-1 ring-slate-200 transition-colors dark:bg-slate-900 dark:ring-slate-800">
                <Image
                  src="/profile-photo/michael-neiter.jpg"
                  alt={t.about.name}
                  width={270}
                  height={270}
                  className="object-cover rounded-2xl"
                  loading="lazy"
                />
              </div>
              <div className="w-full text-center md:[text-align:start]">
                <p className="mt-4 text-base font-semibold text-slate-900 dark:text-slate-100">
                  {t.about.name}
                </p>
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-300">
                  {t.about.title}
                </p>
              </div>
            </div>
          </div>

          {/* Text + chips column */}
          <div className="flex flex-col gap-8">
            <div className="space-y-4">
              <p className={sectionLabelClass}>{t.common.labels.profile}</p>
              <HeadingTag className={`${sectionHeadingClass} rtl:text-right`}>{t.about.heading}</HeadingTag>
              <div className={`space-y-4 ${bodyTextClass}`}>
                {t.about.paragraphs.map((p) => (
                  <p key={p}>{p}</p>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
